import React from 'react'
import useHpSupportRedirect from '../hooks/useHpSupportRedirect'

const HPSupportSpecificLink = ({ children }) => {
  const { canResolveHpSupportLink, hpSupportLink } = useHpSupportRedirect()

  if (!canResolveHpSupportLink || !hpSupportLink) {
    return <>{children}</>
  }

  return (
    <a
      data-testid="hp-support-specific-link"
      href={hpSupportLink}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  )
}

export default HPSupportSpecificLink
